import React from 'react'

import BankAccount from './BankAccount'
import BankWire from './BankWire'
import CreditDebit from './CreditDebit'

import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'
import { useGTMData } from 'hooks/useGTMData'
import { useUTMTracking } from 'hooks/useUTMTracking'
import { PaymentMethodsEnum } from 'pages/RegA/PaymentSelection'
import { IFormProps } from '../../../interfaces'

const Payments = (props: IFormProps) => {
  const sendDataToGTM = useGTMDispatch()
  const gtmData = useGTMData(props.getValues)
  const {
    getFormattedUTMParams, // Helper to generate a complete GTM event object
  } = useUTMTracking()
  const formattedUTMParams = getFormattedUTMParams()
  const renderPaymentSelected = () => {
    switch (props.paymentOptionSelected) {
      case PaymentMethodsEnum.ACH:
        return <BankAccount {...props} />
      case PaymentMethodsEnum.CARD:
        return <CreditDebit {...props} />
      case PaymentMethodsEnum.WIRE:
        return <BankWire {...props} />
      // case 'checkByMail':
      //   return <CheckByMail {...props} />
      // default:
      //   return <CreditDebit {...props} />
      default:
        return <CreditDebit {...props} />
    }
  }

  sendDataToGTM({
    event: 'funnel_step',
    step_title: 'PAYMENTS',
    ...gtmData,
    ...formattedUTMParams,
  })

  return <div>{renderPaymentSelected()}</div>
}

export default Payments
